import { MaterialInput } from 'app/components';
import { Container, IAppState } from 'app/containers/Container'
import { UserActions } from 'app/redux/User/actions'
import * as React from 'react'
import { Alert, Button, Col, FormGroup, Panel, Row } from 'react-bootstrap'

class Confirm extends Container<{}, {}> {
  state = {
    username: '',
    confirmcode: '',
    error: null,
  }

  mapAppStateToContainerState(appState: IAppState): {} {
    return { username: '', confirmcode: '', error: null }
  }

  componentDidMount() {
    const locationSearch = this.getLocationSearch()
    if ('username' in locationSearch && 'confirm' in locationSearch) {
      UserActions.confirm(locationSearch.username, locationSearch.confirm)
        .then(() => location.hash = '#/login')
        .catch((error) => this.setState({ error }));
    }
  }

  confirm(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()
    UserActions.confirm(this.state.username, this.state.confirmcode)
      .then(() => location.hash = '#/login')
      .catch((error) => this.setState({ error }));
  }

  setPartialState(attr: string, value: any) {
    const updateState = {}
    updateState[attr] = value

    this.state.error = null

    this.setState(updateState)
  }

  render() {
    return (
      <section>
        <header className="stripes-container">
          <div className="stripes">
            <div className="s1"></div>
          </div>

          <div className="header-margin">
            <div className="col-lg-4">
              <ul className="breadcrumb">
                <li className="animated fadeIn">
                  Confirm Your Registration
                </li>
              </ul>
            </div>
            <div className="col-lg-3 col-lg-offset-2 col-xs-6 animated fadeIn">

            </div>
            <div className="col-lg-3 col-xs-6 animated fadeIn">

            </div>
          </div>
        </header>
        <section className="container-fluid">
          <Row>
            <Col mdOffset={3} md={6} lgOffset={0} lg={6}>
              <Panel className="animated fadeIn">
                <form name="confirmForm" onSubmit={(e) => this.confirm(e)}>
                  <FormGroup>
                    <MaterialInput placeholder="Username"
                      required={true}
                      onChange={(value) => this.setPartialState('username', value)}
                      value={this.state.username} />
                  </FormGroup>
                  <FormGroup>
                    <MaterialInput placeholder="Confirm Code (recevied in email)"
                      required={true}
                      onChange={(value) => this.setPartialState('confirmcode', value)}
                      value={this.state.confirmcode} />
                  </FormGroup>
                  <FormGroup>
                    <Button type="submit" bsStyle="primary">
                      Register
                    </Button>
                  </FormGroup>

                  {this.state.error ?
                    <FormGroup>
                      <Alert bsStyle="danger" className="animated fadeIn">
                        <strong>
                          <i className="fa fa-fw fa-exclamation-circle" />
                          Uh oh!
                        </strong>
                        <span>
                        </span>
                      </Alert>
                    </FormGroup>
                    : null
                  }
                </form>
              </Panel>
            </Col>
          </Row>
        </section>
      </section>
    )
  }
}

export {
  Confirm
}



// WEBPACK FOOTER //
// ./src/app/containers/Confirm/index.tsx